import Enum from "./Enum";

export default Enum.create( {
	D: "#ED5F74",
	I: "#BB5504",
	S: "#09825D",
	C: "#3A97D4",
} );
